"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const js_joda_1 = require("js-joda");
const pipeable_1 = require("fp-ts/lib/pipeable");
const E = require("fp-ts/lib/Either");
const _1 = require("./");
exports.timeNow = () => LocalTime.of(new Date().getHours(), new Date().getMinutes());
class LocalTime {
    constructor(t) {
        this.t = t;
        this.format = (fmt = 'fi') => this.t.format(_1.localTimeFormatterOf(fmt));
        this.equals = (x) => this.t.equals(x.t);
        this.isAfter = (x) => this.t.isAfter(x.t);
        this.plusHours = (x) => LocalTime.from(this.t.plusHours(x));
        this.plusMinutes = (x) => LocalTime.from(this.t.plusMinutes(x));
    }
}
LocalTime.of = (h, m) => new LocalTime(js_joda_1.LocalTime.of(h, m));
LocalTime.from = (x) => new LocalTime(x);
LocalTime.parse = (x) => exports.tryParseFromPartialValueString(x);
exports.LocalTime = LocalTime;
// parse from 16:00 or 6:00
const tryParseFromValueString = (x) => pipeable_1.pipe(x, E.fromPredicate(v => /^\d{1,2}\:\d{2}/.test(v), () => x), E.chain(value => {
    try {
        return pipeable_1.pipe(js_joda_1.LocalTime.parse(value, _1.localTimeFormatterOf('fi')), E.fromNullable(value), E.map(LocalTime.from));
    }
    catch (e) {
        return E.left(value);
    }
}));
// parse from values
// 1 -> 1:00
// 12 -> 12:00
// 121 -> 12:10
// 1515 -> 15:15
exports.tryParseFromPartialValueString = (x) => pipeable_1.pipe(x, E.fromPredicate(v => /^\d{2,4}$/.test(v), v => v), E.map(v => {
    // append 00 to end of the value, then take first four,...
    const timestr = `${v}00`.slice(0, 4);
    return `${timestr.substring(0, 2)}:${timestr.substring(2, 4)}`;
}), 
// TODO: improve..
// must also parse E.Left, when 00:00 is entered
E.fold(tryParseFromValueString, tryParseFromValueString));
